<p-input-mask
  mask="9999?99-9999"
  [autoClear]="false"
  [disabled]="isDisabled"
  [ngModel]="valueSignal()"
  (ngModelChange)="onValueChange($event)" />

